import { render, staticRenderFns } from "./UIButton.vue?vue&type=template&id=37815ca8&scoped=true&"
import script from "./UIButton.vue?vue&type=script&lang=ts&"
export * from "./UIButton.vue?vue&type=script&lang=ts&"
import style0 from "./UIButton.vue?vue&type=style&index=0&id=37815ca8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37815ca8",
  null
  
)

export default component.exports